import { SelectItem } from '@diamond/shared/types';
import { Dropdown } from '@diamond/shared/ui';
import { useRouter } from 'next/router';
import { FC } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';

import {
  getProductFilterRoute,
  getProductFilters,
} from './useProductFilters';

interface FilterStorageProps {
  storagesData: SelectItem[];
}

type FormProps = {
  storage: string;
};

export const FilterStorage: FC<FilterStorageProps> = ({ storagesData }) => {
  const { pathname, query, push } = useRouter();
  const filters = getProductFilters(query);
  const { register, handleSubmit } = useForm({
    defaultValues: {
      storage: filters.storage_code,
    },
    values: {
      storage: filters.storage_code,
    },
  });

  const submitHandler: SubmitHandler<FormProps> = ({
    storage,
  }: {
    storage: string;
  }) => {
    const url = getProductFilterRoute(pathname, query, {
      cat1: null,
      cat2: null,
      cat3: null,
      storage,
      page: 1,
    });
    push(url, undefined, { shallow: true });
  };

  return (
    <form
      onSubmit={handleSubmit(submitHandler)}
      onChange={handleSubmit(submitHandler)}
    >
      <Dropdown
        name="storage"
        label="Tempat&nbsp;Penyimpanan"
        placeholder="Semua"
        size="md"
        items={storagesData}
        register={register}
      />
    </form>
  );
};
